import React from 'react';

export const CheckoutContext = React.createContext({});

export const useCheckout = () => {
  const context = React.useContext(CheckoutContext);

  if (context === undefined) {
    throw new Error(
      'CheckoutContext cannot be used outside of CheckoutProvider'
    );
  }
  return context;
};
